// **********************************************************
// update cart count in header
// **********************************************************
const updateCartNumber = (number) => {
  const cartIconEl = document.querySelectorAll('.site-header__cart');
  cartIconEl.forEach((item) => {
    const cartIconNumberEl = item.querySelector('.site-header__cart-items');
    if (cartIconNumberEl) {
      if (number === 0) {
        cartIconNumberEl.remove();
      } else {
        cartIconNumberEl.innerHTML = `<p>${number}</p>`;
        cartIconNumberEl.classList.add('text--gray-800');
      }
    } else {
      if (number !== 0) {
        const cartIconNumberElNew = document.createElement('div');
        cartIconNumberElNew.classList.add('site-header__cart-items');
        cartIconNumberElNew.classList.add('text--gray-800');
        cartIconNumberElNew.innerHTML = `<p>${number}</p>`;
        item.appendChild(cartIconNumberElNew);
      }
    }
  });
};

// **********************************************************
// Open Cart Popup
// **********************************************************

attachEvent('.cart-popup-trigger', 'click', (ev) => {
  const cartPopup = document.querySelector('.cart-popup');
  if (cartPopup) {
    const isOpen = cartPopup.classList.contains('is-open-cart');
    cartPopup.classList.toggle('is-open-cart', !isOpen);
    toggleBodyScrollLock(!isOpen);
  }
  ev.preventDefault();
});

// **********************************************************
// Close Popup When Escape Key Press
// **********************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const cartPopupEle = document.querySelectorAll('.cart-popup');
    if (cartPopupEle.length > 0) {
      cartPopupEle.forEach((el) => {
        el.classList.remove('is-open-cart');
        toggleBodyScrollLock(false);
      });
    }
  }
});

// **********************************************************
// Close Popup When Click On Outside
// **********************************************************

attachEvent('.cart-popup__overlay, .cart-popup__close', 'click', (ev) => {
  const parentEle = ev.target.closest('.cart-popup');
  parentEle.classList.remove('is-open-cart');
  ev.preventDefault();
  toggleBodyScrollLock(false);
});

// **********************************************************
// Change Item Quantity In Popup Cart
// **********************************************************
// Axios add/remove item quantity from cart
const axiosChangeQuantityInCart = async (newAmountData, source) => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'changeItemQuantityInCart');
  formDataInput.append('inputs', JSON.stringify(newAmountData));
  formDataInput.append('id', localData.id);
  formDataInput.append('source', source);

  try {
    const response = await axios.post(localData.apiURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    updateCartOnChange(response.data.data.cart_content_html, source);
    updateCartNumber(response.data.data.cart_contents_count);
    document
      .querySelector('.cart-popup')
      .classList.toggle('cart-popup--empty', !response.data.data.cart_contents_count);
    inputFocus();
  } catch (err) {
    console.error(err);
  }
};

// Change Item Quantity Debounce
const debouncePopupAxios = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), timeout);
  };
};

const debounceAxiosChangeQuantityInCart = debouncePopupAxios((newAmountData, source) =>
  axiosChangeQuantityInCart(newAmountData, source),
);

const hasWordPressLoginCookie = document.cookie.split(';').some((cookie) => {
  const name = cookie.trim().split('=')[0];
  return (
    name.startsWith('wordpress_logged_in_') ||
    name.startsWith('woocommerce_cart_hash') ||
    name.startsWith('wp-settings-time-') ||
    name.startsWith('wordpress_test_cookie')
  );
});

// click on add/remove item quantity button
attachEvent('.quantity-counter__button--remove:not(.is-disabled), .quantity-counter__button--add', 'click', (ev) => {
  setTimeout(() => {
    if (!ev.target.closest('.cart-view__item')) {
      return;
    }
    const newAmountData = {
      cart_item_key: ev.target.closest('.cart-view__item').querySelector('.cart-item-key').value,
      quantity: ev.target.closest('.quantity-counter').querySelector('.quantity-counter__input').value,
    };
    const source = ev.target.closest('.cart-popup') ? 'popup' : 'cartPage';
    debounceAxiosChangeQuantityInCart(newAmountData, source);
  }, 50);
});

if (!document.querySelector('header.header-main--purchase-process')) {
  if (document.querySelector('.sc-cart-module')) {
    axiosChangeQuantityInCart({}, 'cartPage');
    document.querySelector('.cart-popup-trigger').style.pointerEvents = 'none';
  } else {
    if (document.querySelector('.purchase-process')) {
      if (document.querySelector('.cart-popup-trigger')) {
        document.querySelector('.cart-popup-trigger').style.pointerEvents = 'none';
      }
    }
    if ((Cookies.get('wishlist_items') && Cookies.get('wishlist_items').replace('[]', '')) || hasWordPressLoginCookie) {
      axiosChangeQuantityInCart({}, 'popup');
    }
  }
}
